module.exports = __webpack_public_path__ + "static/media/react-js-hooks.423a3c28.jpg";